import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {TranslocoService} from "@ngneat/transloco";
import {Operation} from "../model/operation";
import {map} from "rxjs/operators";
import {AlarmType} from "../model/alarm-type";
import {AuditAction} from "../model/audit-action";

@Injectable({
  providedIn: 'root'
})
export class CommonTranslationsService {

  constructor(private readonly i18n: TranslocoService) {
  }

  public getLanguageOptions(): any[] {
    return [
      {name: 'Español', code: 'es', langCode: 'es'},
      {name: 'English', code: 'gb', langCode: 'en'},
      {name: 'Deutsch', code: 'de', langCode: 'de'},
      {name: 'Italiano', code: 'it', langCode: 'it'},
      {name: 'Français', code: 'fr', langCode: 'fr'}
    ];
  }

  public getOperationsTranslation(): Observable<{ [key: string]: string }> {
    return this.i18n.selectTranslation().pipe(map(() => {
      let operationsTranslation: { [key: string]: string } = {};
      operationsTranslation[Operation.EQ] = this.i18n.translate('common.operationEQ');
      operationsTranslation[Operation.GT] = this.i18n.translate('common.operationGT');
      operationsTranslation[Operation.GTE] = this.i18n.translate('common.operationGTE');
      operationsTranslation[Operation.LT] = this.i18n.translate('common.operationLT');
      operationsTranslation[Operation.LTE] = this.i18n.translate('common.operationLTE');
      operationsTranslation[Operation.BYTE_MASK] = this.i18n.translate('common.operationBYTE_MASK');
      operationsTranslation[Operation.INACTIVITY] = this.i18n.translate('common.operationINACTIVITY');
      return operationsTranslation;
    }));
  }

  public getAlarmOperationOptions(): Observable<{ label: string, value: Operation }[]> {
    return this.i18n.selectTranslation().pipe(map(() => {
      return [
        {label: this.i18n.translate('common.operationEQ'), value: Operation.EQ},
        {label: this.i18n.translate('common.operationGT'), value: Operation.GT},
        {label: this.i18n.translate('common.operationGTE'), value: Operation.GTE},
        {label: this.i18n.translate('common.operationLT'), value: Operation.LT},
        {label: this.i18n.translate('common.operationLTE'), value: Operation.LTE},
        {label: this.i18n.translate('common.operationBYTE_MASK'), value: Operation.BYTE_MASK},
        {label: this.i18n.translate('common.operationINACTIVITY'), value: Operation.INACTIVITY}
      ];
    }));
  }

  public getAlarmTypeOptions(): Observable<{ label: string, value: AlarmType }[]> {
    return this.i18n.selectTranslation().pipe(map(() => {
      return [
        {label: this.i18n.translate('common.alarm'), value: AlarmType.ALARM},
        {label: this.i18n.translate('common.event'), value: AlarmType.EVENT},
        {label: this.i18n.translate('common.maintenance'), value: AlarmType.MAINTENANCE},
      ];
    }));
  }

  public getDaysOfWeek(): Observable<string[]> {
    return this.i18n.selectTranslation().pipe(map(() => {
      return this.getDaysOfWeekTranslation();
    }));
  }

  public getDaysOfWeekTranslation(): string[] {
    return [
      this.i18n.translate('time.monday'),
      this.i18n.translate('time.tuesday'),
      this.i18n.translate('time.wednesday'),
      this.i18n.translate('time.thursday'),
      this.i18n.translate('time.friday'),
      this.i18n.translate('time.saturday'),
      this.i18n.translate('time.sunday')
    ];
  }

  public getMonthsOfYear(): Observable<string[]> {
    return this.i18n.selectTranslation().pipe(map(() => {
      return this.getMonthsOfYearTranslations();
    }));
  }

  public getMonthsOfYearTranslations(): string[] {
    return [
      this.i18n.translate('time.january'),
      this.i18n.translate('time.february'),
      this.i18n.translate('time.march'),
      this.i18n.translate('time.april'),
      this.i18n.translate('time.may'),
      this.i18n.translate('time.june'),
      this.i18n.translate('time.july'),
      this.i18n.translate('time.august'),
      this.i18n.translate('time.september'),
      this.i18n.translate('time.october'),
      this.i18n.translate('time.november'),
      this.i18n.translate('time.december')
    ];
  }

  public getDaysOfWeekAndMonthsOfYear(): Observable<{daysOfWeek: string[], monthsOfYear: string[]}> {
    return this.i18n.selectTranslation().pipe(map(() => {
      return {
        daysOfWeek: this.getDaysOfWeekTranslation(),
        monthsOfYear: this.getMonthsOfYearTranslations()
      };
    }));
  }

  public getAuditActions(): Observable<{ label: string, value: AuditAction }[]> {
    return this.i18n.selectTranslation().pipe(map(() => {
      return [
        {label: this.i18n.translate('audits.action.CREATE'), value: AuditAction.CREATE},
        {label: this.i18n.translate('audits.action.UPDATE'), value: AuditAction.UPDATE},
        {label: this.i18n.translate('audits.action.DELETE'), value: AuditAction.DELETE},
        {label: this.i18n.translate('audits.action.COMMAND'), value: AuditAction.COMMAND},
        {label: this.i18n.translate('audits.action.UPLOAD'), value: AuditAction.UPLOAD},
        {label: this.i18n.translate('audits.action.DOWNLOAD'), value: AuditAction.DOWNLOAD}
      ];
    }));
  }

}
